import React, { Component } from 'react'
import InputLabel from './InputLabel'
import Radio from './Radio'

export interface RadioGroupItem {
  name: string
  label: string
}

interface RadioGroupProps {
  label?: string
  radios: RadioGroupItem[]
  checked: RadioGroupItem['name']
  onChange: (name: any) => void
}

export default class RadioGroup extends Component<RadioGroupProps> {
  radio (radio: RadioGroupItem) {
    const checked = (radio.name === this.props.checked)
    return (
      <Radio
        name={radio.name}
        label={radio.label}
        checked={checked}
        onChange={this.props.onChange}
        key={radio.name} />
    )
  }

  get label () {
    return this.props.label &&
      <InputLabel text={this.props.label} />
  }

  get radios () {
    return this.props.radios.map(radio => this.radio(radio))
  }

  render () {
    return (
      <div className="mb-4">
        {this.label}
        <div className="mt-2">
          {this.radios}
        </div>
      </div>
    )
  }
}
